var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Path2D from '../geometry/Path2D';
import { interpolate } from './index';
var actionType = [
    'moveTo',
    'lineTo',
    'arc',
    'arcTo',
    'bezierCurveTo',
    'quadraticCurveTo',
    'ellipse',
    'rect',
];
var interpolatePath = function (from, to, k) {
    var current = to.getPathList().map(function (pathAction, index) {
        var oldPath = from.getPathList()[index];
        if (!oldPath || oldPath.action !== pathAction.action) {
            return pathAction;
        }
        if (actionType.indexOf(pathAction.action) !== -1) {
            return __assign(__assign({}, pathAction), { params: pathAction.params.map(function (param, pIndex) {
                    if (typeof param === 'number') {
                        return interpolate(oldPath.params[pIndex], pathAction.params[pIndex], k);
                    }
                    return param;
                }) });
        }
        return pathAction;
    });
    var currentPath2D = new Path2D();
    currentPath2D.setPathList(current);
    return currentPath2D;
};
export default interpolatePath;
